/**
 * Platform helpers for keyboard-shortcut hints.
 *
 * The app runs on Windows (and macOS for devs), so shortcut hints must not
 * hard-code macOS symbols like ⌘. `shortcut()` renders the right modifier per
 * platform: ⌘ on macOS, `Ctrl` everywhere else. Key handlers already accept
 * both `metaKey` and `ctrlKey`, so this only affects what the label displays.
 */

export const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || "");

/**
 * Render a keyboard-shortcut label for the current platform.
 *
 * @param key A key name such as `"Enter"` or `"K"`.
 * @returns e.g. `"⌘↵"` / `"⌘K"` on macOS, `"Ctrl+Enter"` / `"Ctrl+K"` elsewhere.
 */
export function shortcut(key: string): string {
  if (isMac) {
    return `⌘${key === "Enter" ? "↵" : key}`;
  }
  return `Ctrl+${key}`;
}
